
const _ = require('lodash');

import { Identified } from 'identified';

import { cssClasses } from './model.js';
/**
 * Чем выше приоритет, тем ниже баннер c этим контентом относительно других
 */
export const DEFAULT_CONTENT_PRIORITY = 1;

export class ContextBarContent extends Identified {
	constructor (options) {
		options = _.defaults({}, options, {
			name: 'unnamed',
			above: [],
			below: [],

			visible: true,

			template: undefined,
		});
		super(options);

		this.priority = DEFAULT_CONTENT_PRIORITY;

		this._options = options;

		this.template = this._options.template;
		this.component = null;
		this.cssClasses = cssClasses;
	}

	empty () {
		return !this.template;
	}
	visible () {
		return _.result(this._options, 'visible');
	}
	isBelow (other) {
		return (_.includes(this._options.below, other._options.name))
			|| (_.includes(other._options.above, this._options.name));
	}
	isAbove (other) {
		return (_.includes(this._options.above, other._options.name))
			|| (_.includes(other._options.below, this._options.name));
	}

	dispose () {
		/**placeholder */
	}
}

